import { graphql, useFragment } from "react-relay";
import { WorkspaceBreadcrumbs_workspaces$key } from "./__generated__/WorkspaceBreadcrumbs_workspaces.graphql";
import { AHIcon, AHText, Box } from "arkh";
import React from "react";

export function WorkspaceBreadcrumbs(props: {
  workspaces: WorkspaceBreadcrumbs_workspaces$key;
  currentWorkspaceId: string;
}) {
  const workspaces = useFragment(
    graphql`
      fragment WorkspaceBreadcrumbs_workspaces on Workspace
      @relay(plural: true) {
        id
        name
        parentId
      }
    `,
    props.workspaces
  );

  let breadCrumbs = [];

  let currentWorkspace = workspaces.find(
    (v) => v.id === props.currentWorkspaceId
  );

  while (currentWorkspace) {
    if (
      currentWorkspace.id !== props.currentWorkspaceId ||
      !currentWorkspace.parentId
    ) {
      breadCrumbs.unshift(currentWorkspace);
    }

    if (!currentWorkspace.parentId) {
      currentWorkspace = undefined;
    } else {
      currentWorkspace = workspaces.find(
        (v) => v.id === currentWorkspace?.parentId
      );
    }
  }

  return (
    <Box
      style={{
        flexDirection: "row",

        flex: 1,
      }}
    >
      <AHText type="subtitle" color="darkText" numberOfLines={1}>
        {breadCrumbs.map((v, i, arr) => (
          <React.Fragment key={v.id}>
            <AHText
              key={v.id}
              type="subtitle"
              color="darkText"
              numberOfLines={1}
            >
              {v.name}
            </AHText>
            {arr.length !== i + 1 ? (
              <AHIcon
                spaceHorizontal="xsmall"
                size="xsmall"
                color="washedText"
                type="chevron-right"
              />
            ) : null}
          </React.Fragment>
        ))}
      </AHText>
    </Box>
  );
}
